import { render, staticRenderFns } from "./SparepartRequest.vue?vue&type=template&id=a97a29e6&"
import script from "./SparepartRequest.vue?vue&type=script&lang=ts&"
export * from "./SparepartRequest.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a97a29e6')) {
      api.createRecord('a97a29e6', component.options)
    } else {
      api.reload('a97a29e6', component.options)
    }
    module.hot.accept("./SparepartRequest.vue?vue&type=template&id=a97a29e6&", function () {
      api.rerender('a97a29e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/logistic/sparepart-request/SparepartRequest.vue"
export default component.exports